// bytes into readable format
export function convertSizeInReadable(bytes, fixedLimit = 2) {
    if (!bytes) return "";
    let kb = bytes / 1024;
    let mb = kb / 1024;
    let gb = mb / 1024;

    if (gb >= 1) {
        return `${gb.toFixed(fixedLimit)} GB`;
    } else if (mb >= 1) {
        return `${mb.toFixed(fixedLimit)} MB`;
    } else if (kb >= 1) {
        return `${kb.toFixed(fixedLimit)} KB`;
    } else {
        return `${bytes.toFixed(fixedLimit)} bytes`;
    }
}

export function convertSizeInBytes(num, unit) {
    const unitsMap = {
        bytes: 1,
        KB: 1024,
        MB: 1024 * 1024,
        GB: 1024 * 1024 * 1024,
    };

    const unitLowerCase = unit.toUpperCase();
    if (!unitsMap.hasOwnProperty(unitLowerCase)) {
        throw new Error(`Invalid unit : ${unit}`);
    }

    const multiplier = unitsMap[unitLowerCase];
    if (isNaN(num) || num < 0) {
        throw new Error("Invalid numerical value");
    }

    return num * multiplier;
}
